module.exports = __webpack_public_path__ + "static/media/corporateStep5.1d15d77e.svg";